module.exports = __webpack_public_path__ + "static/media/star-wars-logo2.12f2b846.png";